
import React from 'react';
import StatCard from '@/components/StatCard';
import { Key, Globe, Users, Shield } from 'lucide-react';
import { LicenseKey } from '@/types/licenseKey';

interface MasterDashboardStatsProps {
  licenseKeys: LicenseKey[];
  domains: any[];
  superAdminLicenses: any[];
}

const MasterDashboardStats: React.FC<MasterDashboardStatsProps> = ({ 
  licenseKeys, 
  domains, 
  superAdminLicenses 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      <StatCard 
        title="Total License Keys" 
        value={licenseKeys.length} 
        icon={<Key />}
        description="Active and inactive licenses"
      />
      <StatCard 
        title="Domains" 
        value={domains.length} 
        icon={<Globe />}
        description="Registered domains"
      />
      <StatCard 
        title="Super Admins" 
        value={superAdminLicenses.length} 
        icon={<Users />}
        description="Active Super Admin accounts"
      />
      <StatCard 
        title="Active Licenses" 
        value={licenseKeys.filter(key => key.status === 'active').length} 
        icon={<Shield />}
        description="Currently active licenses"
      />
    </div>
  );
};

export default MasterDashboardStats;
